import styled from 'src/styles/theme';
import { ModalPostalCodeStyled } from '../ModalPostalCodeStyled';

export const ModalPostalCodeStyledOV = styled(ModalPostalCodeStyled)`
    .input {
        button {
            color: ${({ theme }) => theme.colors.black};
        }
    }
`;
